(function (angular) {
    angular.module('app')
        .directive('likes', likesDirective);

        likesDirective.$inject = [
        'UsersApi',
        'thisUser',
        'settings',
        'CommentsApi',
    ];

    function likesDirective (
        UsersApi,
        thisUser,
        CommentsApi,
        settings,
    ) {
        function link($scope) {
            $scope.itemId = $scope.itemId || null;
            $scope.itemType = $scope.itemType || '';
            $scope.likes = $scope.likes || [];

            $scope.getLikes = getLikes;

            const usersFilter = {
                filter_by: null,
                order_by: 'created_at',
                order: 'desc',
                user_id: null,
            }

            const getLikesFilter = {
                filter_by: null,
                order_by: 'created_at',
                order: 'desc',
                user_id: null,
                item_id: $scope.itemId,
            }

            enum API_ROUTE {
                LIKES = '/api/likes',
            }

            function $transform(list: object[]) {
                const handleSuccess = response => {
                    const { data } = response;
                    
                    list.map((item: any) => {
                        const user = data.find(x => x.id === item.user_id);
                        
                        if (user) {
                            const { id, full_name, slug, img, initials } = user;
                            item['user'] = { id, full_name, slug, img, initials };
                        }
                    })

                    return list;
                }
    
                UsersApi.get(usersFilter, handleSuccess);
                return list ?? [];
            }

            function getLikes(): void {
                $scope.likesLoading = true;
                fetch(API_ROUTE.LIKES + '?item_id=' + $scope.itemId, { method: 'GET' }).then(res => res.json()).then(response => {
                    const { data } = response;
                    $scope.likes = data.length ? $transform(data) : [];
                    $scope.likesLoading = false;
                    // console.log('FETCHING likes', response)
                })
            }

            function bootstrap() {
                $scope.isLoading = false;

                if (!$scope.likes.length) {
                    getLikes();
                }
            }

            bootstrap();
        }

        return {
            restrict: 'E',
            templateUrl: 'directives/likes.html',
            transclude: true,
            replace: true,
            link: link,
            scope: {
                likes: '=?',
                itemId: '=?',
                itemType: '=?',
            },
        };
    }

}(angular));